/**
 * 抽取范围
 */
export const ExtractionRangeEnum = {
  ALL: 'ALL',
  FIRST: 'FIRST',
  LAST: 'LAST',
  TARGET: 'TARGET',
} as const;

/** 抽取范围 */
const ExtractionRangeMap: Record<keyof typeof ExtractionRangeEnum, string> = {
  [ExtractionRangeEnum.ALL]: '全文',
  [ExtractionRangeEnum.FIRST]: '首页',
  [ExtractionRangeEnum.LAST]: '末页',
  [ExtractionRangeEnum.TARGET]: '指定页',
} as const;

/** 抽取范围 */
export const extractionRangeOptions = Object.entries(ExtractionRangeEnum).map(
  ([key, value]) => ({
    label: ExtractionRangeMap[key as keyof typeof ExtractionRangeMap],
    value: value,
  }),
);
